export default __webpack_public_path__ + "static/media/logo_dark.c7ecd310.jpg";